export const GET_BANKS = "GET_BANKS";
export const GET_BANKS_SUCCESS = "GET_BANKS_SUCCESS";
export const GET_BANKS_FAIL = "GET_BANKS_FAIL";

export const SAVE_BANKS = "SAVE_BANKS";
export const SAVE_BANKS_SUCCES = "SAVE_BANKS_SUCCES";
export const SAVE_BANKS_ERROR = "SAVE_BANKS_ERROR";

export const DELETE_BANK = "DELETE_BANK";
export const DELETE_BANK_SUCCESS = "DELETE_BANK_SUCCESS";
export const DELETE_BANK_FAIL = "DELETE_BANK_FAIL";

export const EDIT_BANK = "EDIT_BANK";
export const EDIT_BANK_SUCCESS = "EDIT_BANK_SUCCESS";
export const EDIT_BANK_FAIL = "EDIT_BANK_FAIL";
export const INIT_BANK = "INIT_BANK";

